import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { Layout } from './components/Layout.jsx';
import { Home } from './components/Home.jsx';
import { CallBack } from './components/CallBack.jsx';
import { LoginHome } from './components/LoginHome/LoginHome.jsx';
import { JournalsComponent } from './components/Journals/JournalsComponent.jsx';
import { JournalTopics } from './components/Journals/JournalTopics.jsx';
import { JournalsArticle } from './components/Journals/JournalsArticle.jsx';
import { JournalPublication } from './components/Journals/JournalPublication.jsx';
import { JournalIssue } from './components/Journals/JournalIssue.jsx';
import { ManualsComponent } from './components/Manuals/ManualsComponent.jsx';
import { ManualChapter } from './components/Manuals/ManualChapter.jsx';
import { EncyclopediasComponent } from './components/Encyclopedias/EncyclopediasComponent.jsx';
import { EncyclopediaChapter } from './components/Encyclopedias/EncyclopediaChapter.jsx';
import { TopicsComponent } from './components/Topics/TopicsComponent.jsx';
import { TopicDescription } from './components/Topics/TopicDescription.jsx';
import { ShoppingCart } from './components/Shopping Cart/ShoppingCart.jsx';
import { Login } from './components/Login/Login.jsx';
import { ForgotPassword } from './components/Login/ForgotPassword.jsx';
import { GetPassword } from './components/Login/GetPassword.jsx';
import { LoginShoppingCart } from './components/Shopping Cart/LoginShoppingCart.jsx';
import { OrderPlaced } from './components/Shopping Cart/OrderPlaced.jsx';
import { Subscription } from './components/Your Subscription/Subscription.jsx';
import { Maintenance } from './components/Maintenance/Maintenance.jsx';
import { OurContent } from './components/Footer Section/OurContent.jsx';
import { AdvisoryBoard } from './components/Footer Section/AdvisoryBoard.jsx';
import { AboutSubscription } from './components/Footer Section/AboutSubscription.jsx';
import { ContactSales } from './components/Footer Section/ContactSales.jsx';
import { ThankyouSubscription } from './components/Footer Section/ThankyouSubscription.jsx';
import { Feedback } from './components/Maintenance/Feedback.jsx';
import { Etoc } from './components/ETOC Accounts/Etoc.jsx';
import { ManageEtoc } from './components/ETOC Accounts/ManageEtoc.jsx';
import { ManageAccount } from './components/Maintenance/ManageAccount.jsx';
import { SearchContent } from './components/Home/SearchContent.jsx';
import { StaticContent } from './components/Footer Section/';
import { AllManuals } from './components/Manuals/AllManuals.jsx';
import { AllEncyclopedias } from './components/Encyclopedias/AllEncyclopedias.jsx';
import { SearchResult } from './components/Maintenance/SearchResult.jsx';
import { PrivateRoute } from './components/PrivateRoute.jsx';
import { MultiSelectCheckbox } from './components/Home/MultiSelectCheckbox';
import { ContentDelivery } from './components/Footer Section/ContentDelivery.jsx';
import { List } from './components/Home/List.jsx';
import { UserRegistration } from './components/Login/UserRegistration.jsx';
import { Spinner } from './components/Spinner.jsx';
import { Email } from './components/Email/Email.jsx';
import { EtocSuccess } from './components/ETOC Accounts/EtocSuccess.jsx';
import { ChangePassword } from './components/Login/ChangePassword.jsx';
import { sitemap } from './components/Google_Scholar/sitemap';
import { XMLgenerator } from './components/Google_Scholar/XMLgenerator'
import { ResetPassword } from './components/Login/ResetPassword.jsx';
import { GenerateURLLink } from './components/Google_Scholar/GenerateURLLink';
import { UrlRedirect } from './components/Maintenance/UrlRedirect';
import { PaymentResponse } from './components/Shopping Cart/PaymentResponse.jsx';
import { UrlDocRedirect } from './components/Maintenance/UrlDocRedirect';
import { DefaultUrlRedirect } from './components/Maintenance/DefaultUrlRedirect';
import { UrlPubRedirect } from './components/Maintenance/UrlPubRedirect';
import { CitationSearch } from './components/Home/CitationSearch.jsx';
import { EtocAccount } from './components/ETOC Accounts/EtocAccount.jsx';
import { ChangeETOCAccount } from './components/ETOC Accounts/ChangeETOCAccount';
import { AccessibilityKLO } from './components/Maintenance/AccessibilityKLO.jsx';
import { Maintenancepage } from './components/Maintenance/Maintenancepage.jsx';
import { PdfReader } from './components/PdfReader.jsx';
import { SetPassword } from './components/Login/SetPassword.jsx';
import { ContactSalesNew } from './components/Footer Section/ContactSalesNew.jsx';
import { Unsubscribe } from './components/Unsubscribe.jsx';

//import { Route, Switch } from "react-router";

const modules = [
    {
        "path": "/abstract.php", "component": UrlRedirect
    },
    //{
    //    "path": "/document.php", "component": UrlRedirect      
    //},
    {
        "path": "/preview.php", "component": UrlRedirect
    },
    {
        "path": "/productinfo.php", "component": UrlRedirect
    },
    {
        "path": "/toc.php", "component": UrlRedirect
    },
    {
        "path": "/index.php", "component": UrlRedirect
    },
    {
        "path": "/static.php", "component": UrlRedirect
    }
]

const publication = [
    {
        "path": "/airandspacelaw", "component": UrlPubRedirect, "pubId": "18"
    },
    {
        "path": "/asabulletin", "component": UrlPubRedirect, "pubId": "529"
    },
    {
        "path": "/asiandisputereview", "component": UrlPubRedirect, "pubId": "702"
    },
    {
        "path": "/asianinternationalarbitrationjournal", "component": UrlPubRedirect, "pubId": "680"
    },
    {
        "path": "/b-arbitra", "component": UrlPubRedirect, "pubId": "703"
    },
    {
        "path": "/bcdrinternationalarbitrationreview", "component": UrlPubRedirect, "pubId": "681"
    },
    {
        "path": "/businesslawreview", "component": UrlPubRedirect, "pubId": "1"
    },
    {
        "path": "/commonmarketlawreview", "component": UrlPubRedirect, "pubId": "2"
    },
    {
        "path": "/ectaxreview", "component": UrlPubRedirect, "pubId": "19"
    },
    {
        "path": "/europeanbusinesslawreview", "component": UrlPubRedirect, "pubId": "383"
    },
    {
        "path": "/europeancompanylaw", "component": UrlPubRedirect, "pubId": "671"
    },
    {
        "path": "/europeanenergyenvironmentallawreview", "component": UrlPubRedirect, "pubId": "384"
    },
    {
        "path": "/europeanforeignaffairsreview", "component": UrlPubRedirect, "pubId": "412"
    },
    {
        "path": "/europeanpubliclaw", "component": UrlPubRedirect, "pubId": "411"
    },
    {
        "path": "/europeanreviewofprivatelaw", "component": UrlPubRedirect, "pubId": "589"
    },
    {
        "path": "/globaltradeandcustomsjournal", "component": UrlPubRedirect, "pubId": "735"
    },
    {
        "path": "/ijcl", "component": UrlPubRedirect, "pubId": "672"
    },
    {
        "path": "/intertax", "component": UrlPubRedirect, "pubId": "3"
    },
    {
        "path": "/consumerandmarketlaw", "component": UrlPubRedirect, "pubId": "701"
    },
    {
        "path": "/journalofinternationalarbitration", "component": UrlPubRedirect, "pubId": "4"
    },
    {
        "path": "/journalofworldtrade", "component": UrlPubRedirect, "pubId": "408"
    },
    {
        "path": "/legalissuesofeconomicintegration", "component": UrlPubRedirect, "pubId": "580"
    },
    {
        "path": "/revistabrasileiradearbitragem", "component": UrlPubRedirect, "pubId": "700"
    },
    {
        "path": "/worldcompetition", "component": UrlPubRedirect, "pubId": "407"
    },
    {
        "path": "/worldtradeandarbitrationmaterials", "component": UrlPubRedirect, "pubId": "410"
    },
    {
        "path": "/civilprocedure", "component": UrlPubRedirect, "pubId": "706"
    },
    {
        "path": "/commercialandeconomiclaw", "component": UrlPubRedirect, "pubId": "710"
    },
    {
        "path": "/ielcompetitionlaw", "component": UrlPubRedirect, "pubId": "739"
    },
    {
        "path": "/constitutionallaw", "component": UrlPubRedirect, "pubId": "711"
    },
    {
        "path": "/contracts", "component": UrlPubRedirect, "pubId": "712"
    },
    {
        "path": "/corporationspartnerships", "component": UrlPubRedirect, "pubId": "713"
    },
    {
        "path": "/criminallaw", "component": UrlPubRedirect, "pubId": "731"
    },
    {
        "path": "/cyberlaw", "component": UrlPubRedirect, "pubId": "714"
    },
    {
        "path": "/energylaw", "component": UrlPubRedirect, "pubId": "716"
    },
    {
        "path": "/environmentallaw", "component": UrlPubRedirect, "pubId": "732"
    },
    {
        "path": "/familyandsuccession", "component": UrlPubRedirect, "pubId": "717"
    },
    {
        "path": "/insurancelaw", "component": UrlPubRedirect, "pubId": "738"
    },
    {
        "path": "/intellectualproperty", "component": UrlPubRedirect, "pubId": "723"
    },
    {
        "path": "/intergovernmentalorganizations", "component": UrlPubRedirect, "pubId": "720"
    },
    {
        "path": "/iel-laborlaw", "component": UrlPubRedirect, "pubId": "740"
    },
    {
        "path": "/medialaw", "component": UrlPubRedirect, "pubId": "722"
    },
    {
        "path": "/medicallaw", "component": UrlPubRedirect, "pubId": "724"
    },
    {
        "path": "/migrationlaw", "component": UrlPubRedirect, "pubId": "719"
    },
    {
        "path": "/privateinternationallaw", "component": UrlPubRedirect, "pubId": "725"
    },
    {
        "path": "/propertyandtrust", "component": UrlPubRedirect, "pubId": "726"
    },
    {
        "path": "/religionlaw", "component": UrlPubRedirect, "pubId": "728"
    },
    {
        "path": "/socialsecuritylaw", "component": UrlPubRedirect, "pubId": "727"
    },
    {
        "path": "/sportslaw", "component": UrlPubRedirect, "pubId": "736"
    },
    {
        "path": "/tortlaw", "component": UrlPubRedirect, "pubId": "737"
    },
    {
        "path": "/transportlaw", "component": UrlPubRedirect, "pubId": "741"
    },
    {
        "path": "/corporateacquisitionsmergers", "component": UrlPubRedirect, "pubId": "705"
    },
    {
        "path": "/internationalcommerciallitigation", "component": UrlPubRedirect, "pubId": "715"
    },
    {
        "path": "/enforcementforeignjudgements", "component": UrlPubRedirect, "pubId": "707"
    },
    {
        "path": "/europeanairlaw", "component": UrlPubRedirect, "pubId": "709"
    },
    {
        "path": "/internationalbusinesstransactions", "component": UrlPubRedirect, "pubId": "733"
    },
    {
        "path": "/agencydistributionagreements", "component": UrlPubRedirect, "pubId": "718"
    },
    {
        "path": "/labouremploymentcompliance", "component": UrlPubRedirect, "pubId": "721"
    },
    {
        "path": "/maritimelawhandbook", "component": UrlPubRedirect, "pubId": "730"
    },
    {
        "path": "/montrealconvention", "component": UrlPubRedirect, "pubId": "729"
    },
]

export default class App extends Component {
    displayName = App.name

    constructor(props) {
        super(props);
        this.state = { searchtext: '', contenttype: '', istitleonly: false, publication: '', author: '', pubduration: '', pubstartdate: new Date(), pubenddate: new Date(), searchMySub: false, btnSearch: false };
    }

    updateParent(searchtext, contenttype, istitleonly, publication, author, pubduration, pubstartdate, pubenddate, searchMySub, btnSearch) {
        this.setState({
            searchtext: searchtext,
            contenttype: contenttype,
            istitleonly: istitleonly,
            publication: publication,
            author: author,
            pubduration: pubduration,
            pubstartdate: pubstartdate,
            pubenddate: pubenddate,
            searchMySub: searchMySub,
            btnSearch: btnSearch,
            searchkey: searchtext + istitleonly + contenttype + publication + author + pubduration

        });
    }

    updateForAuthor(author) {
        this.setState({
            authorName: author
        });
        //console.log(author);        
    }

    render() {
        return (
            window.location.pathname.toLowerCase() == "/admin" ?
                null
                :
                window.location.pathname.toLowerCase() == "/maintenancepage" ?
                    <Route path='/Maintenancepage' component={Maintenancepage} />
                    :
                    <Layout appCallBack={this.updateParent.bind(this)} AuthorName={this.state.authorName}>
                        {/* Use blow syntax to implement Authentication in Pages */}
                        {/* <PrivateRoute exact path='/' component={Home} /> */}
                        {/*<Route exact path='/' component={() => <Home appAuthorCallBack={this.updateForAuthor.bind(this)} />} />*/}
                        <Switch>
                            <Route exact path='/' component={() => <Home appAuthorCallBack={this.updateForAuthor.bind(this)} />} />
                            <Route path='/LoginHome' component={LoginHome} />
                            <Route path='/CallBack' component={CallBack} />
                            <Route path='/AllJournals' component={JournalsComponent} />
                            <Route path='/Manuals/:title/:id' component={ManualsComponent} />
                            <Route path='/ManualChapter/:title/:id' component={ManualChapter} />
                            <Route path='/Encyclopedias/:title/:id' component={EncyclopediasComponent} />
                            <Route path='/EncyclopediaChapter/:title/:id' component={EncyclopediaChapter} />
                            <Route path='/PracticeAreas' component={TopicsComponent} />
                            <Route path='/PracticeArea' component={TopicDescription} />
                            <Route path='/JournalTopics' component={JournalTopics} />
                            {/* <Route path='/JournalsArticle' component={JournalsArticle} /> */}
                            {/*<Route path='/journalarticle/:title/:volume.:issue/:id' component={JournalsArticle} /> */}
                            <Route path='/journalarticle/:title/:volume.:issue/:id' render={(props) => <JournalsArticle key={props.match.params.id}  {...props} />} />
                            <Route path='/Journals/:title/:id' component={JournalPublication} />
                            {/* <Route path='/JournalIssue' component={JournalIssue} /> */}
                            <Route path='/journalissue/:title/:volume.:issue/:id' render={(props) => <JournalIssue key={props.match.params.id}  {...props} />} />
                            <Route path='/ShoppingCart' component={ShoppingCart} />
                            <Route path='/Login' component={Login} />
                            <Route path='/ForgotPassword' component={ForgotPassword} />
                            <Route path='/Unsubscribe/:email' component={Unsubscribe} />
                            <Route path='/GetPassword' component={GetPassword} />

                            <Route path='/LoginShoppingCart' component={LoginShoppingCart} />
                            <Route path='/OrderPlaced' component={OrderPlaced} />
                            <PrivateRoute path='/Subscription' component={Subscription} />
                            <Route path='/Maintenance' component={Maintenance} />
                            <Route path='/OurContent' component={OurContent} />
                            <Route path='/AdvisoryBoard' component={AdvisoryBoard} />
                            <Route path='/AboutSubscription' component={AboutSubscription} />
                            <Route path='/ContactSales' component={ContactSales} />
                            <Route path='/ContactSalesNew' component={ContactSalesNew} />
                            <Route path='/ThankyouSubscription' component={ThankyouSubscription} />
                            <Route path='/Feedback' component={Feedback} />
                            <Route path='/Etoc' component={Etoc} />
                            <Route path='/ManageEtoc' component={ManageEtoc} />
                            <Route path='/ManageAccount' component={ManageAccount} />
                            <Route path='/SearchContent/:id' render={(props) =>
                                <SearchContent state={this.state} {...props} />} />
                            <Route path='/StaticContent/:page' component={StaticContent} />
                            <Route path='/AllManuals' component={AllManuals} />
                            <Route path='/AllEncyclopedias' component={AllEncyclopedias} />
                            <Route path='/SearchResult' component={SearchResult} />
                            <Route path='/MultiSelectCheckbox' component={MultiSelectCheckbox} />
                            <Route path='/ContentDelivery' component={ContentDelivery} />
                            <Route path='/List' component={List} />
                            {/* <Route path='/UserRegistration' component={UserRegistration} />*/}
                            <Route path='/Email' component={Email} />
                            <Route path='/EtocSuccess' component={EtocSuccess} />
                            <PrivateRoute path='/ChangePassword' component={ChangePassword} />
                            {modules.map(item => <Route exact path={item.path} component={item.component} />)}
                            <Route path='/sitemap' component={sitemap} />
                            <Route path='/XMLgenerator' component={XMLgenerator} />
                            <Route path='/ResetPassword' component={ResetPassword} />
                            <Route path='/GenerateURLLink' component={GenerateURLLink} />
                            <Route path='/PaymentResponse' component={PaymentResponse} />
                            <Route path='/CitationSearch' component={CitationSearch} />
                            <Route path='/EtocAccount' component={EtocAccount} />
                            <Route path='/ChangeETOCAccount' component={ChangeETOCAccount} />
                            <Route path='/AccessibilityKLO' component={AccessibilityKLO} />
                            <Route path='/SetPassword' component={SetPassword} />

                            <Route path='/document.php' component={UrlDocRedirect} />
                            <Route path='/+document.php' component={UrlDocRedirect} />
                            <Route path='/PdfReader/:fileType/:code/:pdffile' component={PdfReader} />
                            {
                                publication.map(item => <Route
                                    path={item.path}
                                    render={(props) => <UrlPubRedirect {...props} pubId={item.pubId} />}
                                />
                                )}
                            <Route component={DefaultUrlRedirect} />
                        </Switch>
                    </Layout>

        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js